import { QueryObserver as Mt } from './contact-channels65.js';
import { useBaseQuery as A } from './contact-channels66.js';

function m(r,o){return A(r,Mt)}

export { m as useQuery };
//# sourceMappingURL=contact-channels37.js.map
